import { Token } from '@uniswap/sdk-core'
import { FeeAmount } from '@uniswap/v3-sdk'
import { useEffect, useMemo, useState } from 'react'
import { useV3Factory } from './useContract'
import { useSingleCallResult } from 'state/multicall/hooks'
import { ZERO_ADDRESS } from '../constants'

export function useV3PairExists(
  token0: Token | undefined,
  token1: Token | undefined,
  feeAmount: FeeAmount | undefined
): {
  address: string
  exists: boolean
} {
  const [exists, setExists] = useState<boolean>(false)

  const factoryContract = useV3Factory()
  const poolAddress = useSingleCallResult(factoryContract, 'getPool', [token0?.address, token1?.address, feeAmount])
    .result?.[0]

  useEffect(() => {
    if (poolAddress !== undefined) {
      setExists(poolAddress !== ZERO_ADDRESS)
    }
  }, [poolAddress])

  return useMemo(
    () => ({
      address: poolAddress,
      exists,
    }),
    [exists, poolAddress]
  )
}
